import { render, staticRenderFns } from "./quickOrder2.vue?vue&type=template&id=0ee1eca6&scoped=true"
import script from "./quickOrder2.vue?vue&type=script&lang=js"
export * from "./quickOrder2.vue?vue&type=script&lang=js"
import style0 from "./quickOrder2.vue?vue&type=style&index=0&id=0ee1eca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee1eca6",
  null
  
)

export default component.exports